import { render, staticRenderFns } from "./MappedSuppliersModal.vue?vue&type=template&id=1c8d77fc&"
import script from "./MappedSuppliersModal.vue?vue&type=script&lang=js&"
export * from "./MappedSuppliersModal.vue?vue&type=script&lang=js&"
import style0 from "./MappedSuppliersModal.vue?vue&type=style&index=0&id=1c8d77fc&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c8d77fc')) {
      api.createRecord('1c8d77fc', component.options)
    } else {
      api.reload('1c8d77fc', component.options)
    }
    module.hot.accept("./MappedSuppliersModal.vue?vue&type=template&id=1c8d77fc&", function () {
      api.rerender('1c8d77fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/MappedSuppliersModal.vue"
export default component.exports